<template>
  <AppWithLoading v-slot:default="{ loader }">
    <VCard class="dialog">
      <VCardTitle :class="textClass" class="dialog-header justify-start mb-1 flex-column align-start">
        <img
          :src="require('@/assets/img/tarrif-change-warning.svg')"
          alt="warning"
          class="dialog-header__icon"
        >
        <VBtn
          class="v-btn__close"
          icon
          small
          absolute
          top
          right
          @click="$emit('close')"
        >
          <IconClose />
        </VBtn>
        <div v-if="title" class="dialog-header__text">
          {{ title }}
        </div>
      </VCardTitle>
      <VCardText v-if="text" class="dialog-text">
        {{ text }}
      </VCardText>
      <slot name="btn">
        <VBtn
          class="v-btn__send mb-0"
          color="success"
          id="inviteBtn"
          @click="loader(() => redirectToUpgradePlan())"
        >
          {{ $t('toUpgradePlan') }}
        </VBtn>
      </slot>
    </VCard>
  </AppWithLoading>
</template>

<script>
import { paymentTabs, settingsTabs } from '@/enums';
import AppWithLoading from '@/components/AppWithLoading';
import IconClose from './SvgIcons/Close.vue';

export default {
  name: 'DialogTariffChange',
  components: { AppWithLoading, IconClose },
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    text: {
      type: String,
      default: '',
      required: false,
    },
    textClass: {
      type: String,
      default: 'dark--text',
    },
  },
  methods: {
    async redirectToUpgradePlan() {
      this.$emit('close');
      await this.$router.push({
        name: 'settings',
        params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLANS },
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .v-btn {
    &__send {
      width: 100%;
      font-weight: 400;
      font-size: 16px;
      line-height: 19.2px;
      margin-bottom: 30px;
    }
    &__close {
      top: 15px;
      right: 15px;
    }
  }

  .dialog {
    padding: 30px;
    border-radius: 8px !important;
    color: #212121 !important;
  }

  .dialog-header {
    font-weight: 400;
    font-size: 24px;
    line-height: 26px;
    padding: 0;
    &__icon {
      padding: 13px;
      background: rgba(234, 13, 13, 0.1);
      border-radius: 50%;
    }
    &__text {
      text-align: start;
      margin: 20px 0;
    }
  }
  .dialog-text {
    padding: 0;
    margin-bottom: 40px;
    font-size: 14px;
    line-height: 19.6px;
    font-weight: 300;
  }
</style>

<i18n locale="en" lang="yaml">
toUpgradePlan: Upgrade plan
multiuser-na: Multi-user mode is unavailable with your plan
</i18n>

<i18n locale="ru" lang="yaml">
toUpgradePlan: Повысить тариф
multiuser-na: Многопользовательский режим недоступен на вашем тарифе
</i18n>
